import React from 'react';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { H4, H5, P, UL, LI } from '../../../AbstractElements';
import { CompletedGoal, ExpectedGoal, New, OurGoalOverview, ThisYearGoal, TotalProfit } from '../../../Constant';
import ApexChart from 'react-apexcharts';
import { GoalOverviewOptions } from '../../../Data/DashBoard/Ecommerce/ApexChart';

const GoalOverview = () => {
  return (
    <>
      <Col xl='4' md='6' className='box-col-4'>
        <Card className='goal-view'>
          <CardHeader className='card-no-border dflex justify-content-between'>
            <H5>{OurGoalOverview}</H5>
            <div className='center-content'>
              <P>{ThisYearGoal}</P>
            </div>
          </CardHeader>
          <CardBody className='p-0'>
            <div className='profit-goal'>
              <H4>
                $78,486.65<span className='badge badge-primary ms-3'>{New}</span>
              </H4>
              <P>{TotalProfit}</P>
            </div>
            <ApexChart className='goal-review' series={GoalOverviewOptions.series} options={GoalOverviewOptions.options} type='line' height={235} />
          </CardBody>
          <UL className='goal-list'>
            <LI>
              <H4>65%</H4>
              <P>{CompletedGoal}</P>
            </LI>
            <LI>
              <H4>96%</H4>
              <P>{ExpectedGoal}</P>
            </LI>
          </UL>
        </Card>
      </Col>
    </>
  );
};

export default GoalOverview;
